import React from 'react';
import { cn } from '@/lib/utils'; // Assuming utils exist or need to be created

interface UploadProgressProps {
    progress: number;
    status: 'idle' | 'uploading' | 'processing' | 'completed' | 'error';
    fileName?: string;
    className?: string;
}

export function UploadProgress({ progress, status, fileName, className }: UploadProgressProps) {
    return (
        <div className={cn("w-full max-w-md mx-auto p-4 bg-card rounded-xl border border-border shadow-sm", className)}>
            <div className="flex justify-between items-center mb-2">
                <span className="text-sm font-medium text-foreground truncate max-w-[200px]">
                    {fileName || 'Uploading video...'}
                </span>
                <span className="text-xs text-muted-foreground font-medium">
                    {status === 'processing' ? 'Processing...' : `${progress}%`}
                </span>
            </div>

            <div className="h-2 w-full bg-secondary rounded-full overflow-hidden">
                <div
                    className={cn(
                        "h-full bg-primary transition-all duration-300 ease-out",
                        status === 'processing' && "animate-pulse bg-blue-500",
                        status === 'completed' && "bg-green-500",
                        status === 'error' && "bg-red-500"
                    )}
                    style={{ width: `${progress}%` }}
                />
            </div>

            <div className="mt-2 text-xs text-muted-foreground text-center">
                {status === 'uploading' && "Uploading to secure storage..."}
                {status === 'processing' && "Analyzing audio and detecting markers..."}
                {status === 'completed' && "Upload complete! Redirecting..."}
                {status === 'error' && "Upload failed. Please try again."}
            </div>
        </div>
    );
}
